var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21653 14.0029C5.05653 14.0029 4.89553 13.9519 4.75953 13.8479C4.43153 13.5949 4.36953 13.1239 4.62253 12.7959L7.61553 8.90587C7.73753 8.74687 7.91853 8.64387 8.11653 8.61887C8.31853 8.59287 8.51653 8.64887 8.67353 8.77387L11.4935 10.9889L13.9605 7.80587C14.2145 7.47687 14.6845 7.41587 15.0125 7.67187C15.3405 7.92587 15.4005 8.39687 15.1465 8.72387L12.2165 12.5039C12.0945 12.6619 11.9145 12.7649 11.7165 12.7889C11.5165 12.8159 11.3185 12.7579 11.1605 12.6349L8.34253 10.4209L5.81153 13.7099C5.66353 13.9019 5.44153 14.0029 5.21653 14.0029Z",
    fill: "#878787"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1248_26640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 6,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2954 0.00012207H20.6394V5.34502H15.2954V0.00012207Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1248_26640)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9674 1.5C17.3214 1.5 16.7954 2.025 16.7954 2.672C16.7954 3.318 17.3214 3.845 17.9674 3.845C18.6134 3.845 19.1394 3.318 19.1394 2.672C19.1394 2.025 18.6134 1.5 17.9674 1.5ZM17.9674 5.345C16.4944 5.345 15.2954 4.146 15.2954 2.672C15.2954 1.198 16.4944 0 17.9674 0C19.4414 0 20.6394 1.198 20.6394 2.672C20.6394 4.146 19.4414 5.345 17.9674 5.345Z",
    fill: "#878787"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1248_26640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.842163H19.8619V20.7032H0V0.842163Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1248_26640)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.233 20.7032H5.629C2.262 20.7032 0 18.3382 0 14.8182V6.73616C0 3.21116 2.262 0.842163 5.629 0.842163H12.897C13.311 0.842163 13.647 1.17816 13.647 1.59216C13.647 2.00616 13.311 2.34216 12.897 2.34216H5.629C3.121 2.34216 1.5 4.06616 1.5 6.73616V14.8182C1.5 17.5232 3.082 19.2032 5.629 19.2032H14.233C16.741 19.2032 18.362 17.4822 18.362 14.8182V7.77916C18.362 7.36516 18.698 7.02916 19.112 7.02916C19.526 7.02916 19.862 7.36516 19.862 7.77916V14.8182C19.862 18.3382 17.6 20.7032 14.233 20.7032Z",
    fill: "#878787"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaoIcon);
export default __webpack_public_path__ + "static/media/iao-icon.1c57b2479b3bfa792d77e9cda49f0893.svg";
export { ForwardRef as ReactComponent };